/**
 * TinyMCE treats HTML carrying this comment as an internal paste and keeps
 * inline styles. Without it, Chrome/Safari run paste_remove_styles_if_webkit
 * and strip every style="..." from external clipboard HTML.
 */
export const TINYMCE_INTERNAL_MARK = "<!-- x-tinymce/html -->";

/**
 * Wrap a fragment so paste targets (TinyMCE, Outlook, Word, Gmail) receive a
 * real HTML document rather than a bare snippet. TinyMCE's trimHtml extracts
 * the body and drops the StartFragment comments, leaving the internal mark.
 */
export function wrapHtmlForClipboard(html) {
  const fragment = `${TINYMCE_INTERNAL_MARK}${html ?? ""}`;
  return `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body><!--StartFragment-->${fragment}<!--EndFragment--></body></html>`;
}

export function copyHtmlToClipboard(html, plainText = "") {
  const wrapped = wrapHtmlForClipboard(html);
  if (typeof ClipboardItem !== "undefined" && navigator.clipboard?.write) {
    const blob = new Blob([wrapped], { type: "text/html" });
    const plain = new Blob([plainText || ""], { type: "text/plain" });
    return navigator.clipboard.write([new ClipboardItem({ "text/html": blob, "text/plain": plain })]);
  }
  return navigator.clipboard.writeText(html);
}

export function htmlLooksStyled(html) {
  return typeof html === "string" && /style\s*=/i.test(html);
}
